interface JwtPayload {
  [key: string]: unknown;
  exp?: number;
}

export const decodeJwtPayload = (token: string): JwtPayload | null => {
  try {
    const parts = token.split('.');

    if (parts.length !== 3) {
      return null;
    }

    const payload = parts[1];
    const padded = payload + '='.repeat((4 - (payload.length % 4)) % 4);
    const decoded = atob(padded.replace(/-/g, '+').replace(/_/g, '/'));

    return JSON.parse(decoded) as JwtPayload;
  } catch {
    return null;
  }
};

/**
 * Returns true if the token is expired or will expire within bufferSeconds.
 * The buffer prevents edge cases where a token is valid at check time but
 * expires before the request completes.
 */
export const isTokenExpired = (token: string, bufferSeconds = 60): boolean => {
  const payload = decodeJwtPayload(token);

  if (!payload || typeof payload['exp'] !== 'number') {
    return true;
  }

  return payload['exp'] < Date.now() / 1000 + bufferSeconds;
};
